<template>
  <div>
    <div class="grey-subhead-bg text-uppercase">
      <h1>Search for your product</h1>
    </div>

    <div class="container">
      <br />
      <div class="row text-center">
        <div class="col-xs-6 col-xs-offset-3">
          <div class="col-xs-12">
            <input
              type="text"
              class="form-control client-form-control input-lg"
              placeholder="Invoice / Receipt Number"
              v-model="invoiceData.receiptNumber"
            >
          </div>
          <div class="col-xs-12">
            <datepicker
              v-model="invoiceData.dateOfPurchase"
              input-class="input-white form-control client-form-control input-lg"
              placeholder="Date of Purchase"
            >
            </datepicker>
          </div>
          <div class="clearfix"></div>
          <div>
            <input
              id=""
              type="file"
              name=""
              ref="imageFile"
              @change="uploadToS3"
              style="display:none">
            <a
              href=""
              type="button"
              v-if="!loading"
              :class="uploadBtnClasses"
              @click.prevent="triggerInput"
            >
              Upload Invoice Receipt
            </a>
            <small>(JPG, JPEG, PNG, or PDF; of a file size not larger than 5MB)</small>
            <br>
            <br>
          </div>
          <spinner v-if="loading" message="Uploading..." text-fg-color="#fff" :speed="1"></spinner>
          <br />
        </div>
        <div class="clearfix"></div>
        <div class="col-sm-6 col-sm-offset-3">
          <a
            href
            type="button"
            class="btn client-btn-primary btn-lg btn-block text-uppercase"
            @click.prevent="goItemSearch"
          >Continue</a>
          <br />
          <a
            href=""
            type="button"
            class="btn client-btn-primary btn-lg btn-block text-uppercase"
            @click.prevent="$router.go(-1)"
          >
            <span class="glyphicon-chevron-left glyphicon"></span> Back
          </a>
        </div>
      </div>
      <br />
      <br />
    </div>
    <!-- container-fluid -->
  </div>
</template>

<script>
import DatePicker from 'vuejs-datepicker'
import S3 from '../../../_helpers/awsS3'
import Spinner from 'vue-simple-spinner'
import { mapActions, mapState } from 'vuex'

const crypto = require('crypto')

export default {
  name: 'InvoiceDetails',
  components: {
    datepicker: DatePicker,
    spinner: Spinner
  },
  props: {
    invoiceData: {}
  },
  data () {
    return {
      errorMessageMap: {
        'receipt-exists': 'This receipt exists',
        'receipt-submitted': 'This receipt has been submitted',
        'receipt-approved': 'This receipt has been approve'
      },
      file: null,
      loading: false,
      receiptData: {
        dateOfPurchase: '',
        receiptNumber: '',
        image: {
          url: null,
          fileName: null,
          randomString: null,
          imageKey: null
        }
      },
      validFileTypes: [
        'image/png',
        'image/jpg',
        'image/jpeg',
        'application/pdf'
      ]
    }
  },
  computed: {
    uploadBtnClasses () {
      const common = 'btn client-btn-primary btn-lg btn-block text-uppercase'
      return this.invoiceData.image.url ? common + ' disabled' : common
    },
    ...mapState('loyaltyProgram', {
      fields: state => state.program.rebateItemFields
    }),
    ...mapState('auth', {
      ulpId: state => state.user.userLoyaltyProgram._id
    }),
    searchableFields () {
      return this.fields.filter(field => field.searchable)
    }
  },
  methods: {
    ...mapActions('receipt', ['validateNewReceipt']),
    generateRandomString () {
      return crypto.randomBytes(20).toString('hex')
    },
    triggerInput (event) {
      this.$refs.imageFile.click()
    },
    uploadToS3 () {
      this.loading = true
      const file = this.$refs.imageFile.files[0]
      if (!file) {
        this.loading = false
        this.$refs.imageFile.value = ''
        return
      }
      if (!this.validFileTypes.includes(file.type.toLowerCase()) || file.size > 5000000) {
        this.loading = false
        this.$refs.imageFile.value = ''
        return alert('File extension must be png, jpg, jpeg, or pdf. File size cannot exceed 5MB.')
      }
      this.file = file
      this.invoiceData.image.fileName = file.name
      this.invoiceData.image.randomString = this.generateRandomString()
      const albumPhotosKey = encodeURIComponent('receipts') + '/'
      this.invoiceData.image.imageKey = `${albumPhotosKey}${this.invoiceData.image.randomString}-${this.invoiceData.image.fileName}`
      S3.uploadToS3(this.invoiceData.image.imageKey, this.file)
        .then(result => {
          this.invoiceData.image.url = result.Location
          this.loading = false
          alert('Submission successful.')
        })
        .catch(err => {
          console.log(err.message)
          alert('Submission error, please try again. ', err.message)
        })
    },
    async goItemSearch () {
      let errors = this.validate()
      if (errors.length > 0) {
        errors.forEach((error, idx) => {
          setTimeout(() => this.$bus.emit('notify', { message: error, type: 'danger' }), 500 * idx)
        })
        return
      }
      let backendResult = await this.dbVerify()
      if (!backendResult.success) {
        this.$bus.emit('notify', { message: this.errorMessageMap[backendResult.type], type: 'danger' })
        return
      }
      this.$bus.emit('swapComponent', { component: 'item-search' })
    },
    validate () {
      let errors = []
      if (!this.invoiceData.dateOfPurchase) errors.push('Transaction date required.')
      if (!this.invoiceData.receiptNumber) {
        errors.push('Invoice/Receipt number is required')
      } else {
        if (isNaN(this.invoiceData.receiptNumber)) errors.push('Invoice/Receipt number must be a number')
      }
      if (!this.invoiceData.image.url) {
        errors.push('Invoice/Receipt file is required')
      }
      return errors
    },
    async dbVerify () {
      try {
        const valid = await this.validateNewReceipt({
          receiptNumber: this.invoiceData.receiptNumber,
          userLoyaltyProgramId: this.ulpId
        })
        return valid.data
      } catch (error) {
        return error.response.data
      }
    }
  }
}
</script>
